import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { formatCurrency } from '../../utils/formatters';
import { ReceivablesRow } from './ReceivablesRow';
import { ReceivablesTile } from './ReceivablesTile';
import type { ReceivablesSummaryDto } from '../../types/kpi/receivablesSummary';
import { ReceivablesRowSkeleton } from './ReceivablesRowSkeleton';

interface ReceivablesSummaryProps {
    summary: ReceivablesSummaryDto | null;
    pending: boolean;
}

/**
 * The portfolio at a glance, above the reminder tabs. Reads the portfolio, not the work list:
 * a customer with nothing yet due and a postponed reminder both count.
 */
export const ReceivablesSummary: React.FC<ReceivablesSummaryProps> = ({ summary, pending }) => {
    const { t } = useTranslation();

    if (pending) return <ReceivablesRowSkeleton count={3} testId="receivables-summary-skeleton" />;
    if (!summary) return null;

    return (
        <section data-testid="receivables-summary">
            <ReceivablesRow>
                <ReceivablesTile
                    testId="receivables-overdue"
                    label={t(TranslationKey.Home.Receivables.Overdue)}
                    value={formatCurrency(summary.overdue)}
                />
                <ReceivablesTile
                    testId="receivables-total"
                    label={t(TranslationKey.Home.Receivables.Total)}
                    value={formatCurrency(summary.totalReceivable)}
                />
                <ReceivablesTile
                    testId="receivables-over90"
                    label={t(TranslationKey.Home.Receivables.Over90)}
                    value={formatCurrency(summary.over90Days)}
                />
            </ReceivablesRow>
        </section>
    );
};
